import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const VehicleRegNo = (props) => {
  return (
    <FormGroup controlId="vehicleRegNo">
      <Col componentClass={ControlLabel} sm={5}>
        Vehicle Reg. No.
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.vehicleRegNo}
            onBlur={() => props.validation(true)}
            onChange={props.handleChangeVehicleRegNo}
            autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

VehicleRegNo.propTypes = {
  vehicleRegNo: PropTypes.string,
  validation: PropTypes.func,
  handleChangeVehicleRegNo: PropTypes.func
};

export default VehicleRegNo;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/vehicleRegNo/VehicleRegNo.js